/**
 * NoticeListContainer
 * --
 */
import React from 'react';
import NoticeListPresenter from './NoticeListPresenter';

const NoticeListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <NoticeListPresenter />
    </>
  );
};

export default NoticeListContainer;
